export default "__VITE_ASSET__c97d038b__"